import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'start-window',
  templateUrl: './start-window.component.html',
  styleUrls: ['./start-window.component.scss']
})
export class StartWindowComponent implements OnInit {

  showVideoModal = false;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  openVideoModal() {
    this.showVideoModal = true;
  }

  closeVideoModal() {
    this.showVideoModal = false;
  }

  redirectTo(url: string) {
    this.router.navigate([url]);
  }

}
